import React, { useEffect, useRef } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

export default function OpenStreetMapPicker({ lat, lon, onChange }) {
  const container = useRef(null);
  const map = useRef(null);
  const marker = useRef(null);
  const initialPosition = useRef([Number(lat) || 51.5074, Number(lon) || -0.1278]);
  const onChangeRef = useRef(onChange);
  onChangeRef.current = onChange;

  useEffect(() => {
    if (!container.current || map.current) return undefined;
    const initial = initialPosition.current;
    map.current = L.map(container.current).setView(initial, 12);
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; OpenStreetMap contributors',
      maxZoom: 19
    }).addTo(map.current);
    marker.current = L.marker(initial, { draggable: true }).addTo(map.current);
    const select = (event) => onChangeRef.current(Number(event.latlng.lat.toFixed(6)), Number(event.latlng.lng.toFixed(6)));
    map.current.on('click', select);
    marker.current.on('dragend', (event) => select(event.target.getLatLng()));
    return () => { map.current?.remove(); map.current = null; marker.current = null; };
  }, []);

  useEffect(() => {
    if (!marker.current || !map.current) return;
    const position = [Number(lat) || 51.5074, Number(lon) || -0.1278];
    marker.current.setLatLng(position);
    map.current.panTo(position);
  }, [lat, lon]);

  return <div ref={container} className="map-canvas" />;
}
